import axios from 'axios';

const storeStatisticsApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Statistics/store?store_id=${
      paramsFilter?.store_id || ''
    }&date=${paramsFilter?.date || ''}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default storeStatisticsApi;
